module.exports = __webpack_public_path__ + "img/UTGUNL-3.b8924c7a.jpg";